import { render, staticRenderFns } from "./voettekst.vue?vue&type=template&id=4ccdb746&"
import script from "./voettekst.vue?vue&type=script&lang=js&"
export * from "./voettekst.vue?vue&type=script&lang=js&"
import style0 from "./voettekst.vue?vue&type=style&index=0&id=4ccdb746&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports